export const baseUrl = '/service-sites'
